import React from "react";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Pppoe from "../../../assets/images/pppoe.png";
import Dinamico from "../../../assets/images/dinamico.png";
import Estatico from "../../../assets/images/estatico.png";

const TiposConexao = () => {
    return (
        <>
            <p>
                A Função Principal: O principal objetivo de um roteador residencial é rotear o tráfego de dados entre sua rede local wi-fi ou cabo e a Internet. Ele faz isso ao atribuir endereços
                <OverlayTrigger key="ip" placement="top" overlay={<Tooltip>"Internet Protocol" (protocolo de rede)</Tooltip>}>
                    <span className="tooltip-trigger">{' '}<strong>IP</strong></span>
                </OverlayTrigger>
                , através do servidor{' '}
                <OverlayTrigger key="dhcp" placement="top" overlay={<Tooltip>"Dynamic Host Configuration Protocol" (Protocolo de configuração de host dinâmico)</Tooltip>}>
                    <span className="tooltip-trigger"><strong>DHCP</strong></span>
                </OverlayTrigger>
                {' '}aos dispositivos em sua rede local e encaminhar os pacotes de dados entre esses dispositivos e a Internet.
            </p>
            <p>

            </p>
            <p>
                Configurando um Roteador Wi-fi: A configuração de um roteador pode variar de acordo com o cenário, e é importante avaliar
                cada situação adequadamente. Vamos começar com conhecendo os pricipais tipos de conexão com a internet.
            </p>
            <h1>Tipos de Conexão à Internet:</h1>
            <p>
                PPPoE (Point-to-Point Protocol over Ethernet): É um método de autenticação amplamente utilizado por ISPs (provedores de serviços de Internet) que requer
                um nome de usuário e senha para se conectar à Internet. O roteador autentica-se junto ao ISP usando essas credenciais.
            </p>
            <div className="pppoe">
                <img src={Pppoe} alt="pppoe" />
            </div>
            <span>
                Obs. Método pouco utilizado, somente por ONUs Cianet.
            </span>
            <br /><br />
            <p>
                IP Dinâmico: Nesse modo de conexão, o ISP atribui um endereço IP dinâmico ao roteador sempre que ele se conecta à Internet.
                Isso é comum em conexões residenciais.
            </p>
            <div className="dinamico">
                <img src={Dinamico} alt="dinamico" />
            </div>
            <span>
                Obs. Método utilizado com roteadores com PRESET "Estamos implementando uma tecnologia inovadora: um aplicativo de Wi-Fi que permite aos clientes gerenciar sua própria rede com facilidade."
            </span>
            <br /><br />
            <p>
                IP Estático: Com essa configuração, o ISP
                atribui um endereço IP estático fixo ao roteador. Isso é mais comum em configurações empresariais.
            </p>
            <div className="estatico">
                <img src={Estatico} alt="estatico" />
            </div>
            <span>
                Obs. Método de configuração utilizado quando solicitado pelo cliente."
            </span>
        </>
    );
};
export default TiposConexao;